/**
 *
 * CollaboratorsCreate
 *
 */

import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { FormattedMessage } from "react-intl"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Loader from "components/Loader"
import CollaboratorsCreateTemplate from "components/CollaboratorsCreateTemplate"
import { is } from "immutable"
import {
  MakeSelectDivisions,
  MakeSelectCategories,
  MakeSelectCurrency,
  MakeSelectIsLoadingDivisions,
  MakeSelectLeaders,
  MakeSelectGenders,
  MakeSelectIsCreating,
  MakeSelectLocations,
  MakeSelectIsLoadingGenders,
  MakeSelectIsLoadingEmployees,
  MakeSelectIsLoadingCategories,
  MakeSelectIsLoadingLocations,
} from "./selectors"

import reducer from "./reducer"
import saga from "./saga"

import messages from "./messages"
import { getDivisionsWatcher, createCollaboratorWatcher, getGendersWatcher, getEmployeesWatcher, getCategoriesWatcher, getLocationsWatcher } from "./actions"
/* eslint-disable react/prefer-stateless-function */
export class CollaboratorsCreate extends React.Component {
  UNSAFE_componentWillMount() {
    this.props.getData()
    this.props.getGenders()
    this.props.getLeaders()
    this.props.getCategories()
    this.props.getLocations()
  }

  render() {
    const {
      divisions,
      categories,
      currency,
      createCollaborator,
      leaders,
      genders,
      locations,
      isCreating,
      isLoadingDivisions,
      isLoadingGenders,
      isLoadingLeaders,
      isLoadingCategories,
      isLoadingLocations
    } = this.props

    return (
      <React.Fragment>
        <Helmet>
          <title>Organización - Colaboradores</title>
          <meta
            name="description"
            content="Description of CollaboratorsCreate"
          />
        </Helmet>
        <CollaboratorsCreateTemplate
          isLoadingDivisions={isLoadingDivisions}
          isLoadingGenders={isLoadingGenders}
          isLoadingLeaders={isLoadingLeaders}
          isLoadingCategories={isLoadingCategories}
          isLoadingLocations={isLoadingLocations}
          divisions={divisions}
          categories={categories}
          currency={currency}
          leaders={leaders}
          createCollaborator={createCollaborator}
          genders={genders}
          locations={locations}
          isCreating={isCreating}
          history={this.props.history}
        />
      </React.Fragment>
    )
  }
}

CollaboratorsCreate.propTypes = {
  divisions: PropTypes.array.isRequired || PropTypes.object.isRequired,
  categories: PropTypes.array.isRequired || PropTypes.object.isRequired,
  currency: PropTypes.array.isRequired || PropTypes.object.isRequired,
  isLoadingDivisions: PropTypes.bool.isRequired,
}

const mapStateToProps = createStructuredSelector({
  divisions: MakeSelectDivisions(),
  categories: MakeSelectCategories(),
  currency: MakeSelectCurrency(),
  leaders: MakeSelectLeaders(),
  genders: MakeSelectGenders(),
  locations: MakeSelectLocations(),
  isLoadingDivisions: MakeSelectIsLoadingDivisions(),
  isLoadingGenders: MakeSelectIsLoadingGenders(),
  isLoadingLeaders: MakeSelectIsLoadingEmployees(),
  isLoadingCategories: MakeSelectIsLoadingCategories(),
  isLoadingLocations: MakeSelectIsLoadingLocations(),
  isCreating: MakeSelectIsCreating(),
})

function mapDispatchToProps(dispatch) {
  return {
    getData: () => dispatch(getDivisionsWatcher()),
    getGenders: () => dispatch(getGendersWatcher()),
    getLeaders: () => dispatch(getEmployeesWatcher()),
    getCategories: () => dispatch(getCategoriesWatcher()),
    getLocations: () => dispatch(getLocationsWatcher()),
    createCollaborator: (params) => dispatch(createCollaboratorWatcher(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "collaboratorsCreate", reducer })
const withSaga = injectSaga({ key: "collaboratorsCreate", saga })

export default compose(withReducer, withSaga, withConnect)(CollaboratorsCreate)
